const getBoardSize = boardPortraitLayout => {
  if (boardPortraitLayout) {
    const array = boardPortraitLayout.split('x');
    return parseInt(array[0], 10) * parseInt(array[1], 10);
  } else {
    return 0;
  }
};

export default getBoardSize;
